import React from "react";
import { HOLD_LEVEL_LEGEND } from "../../utils/eventStatus";
import "./StatusChip.css";

export type EventStatusTone =
  | "hold"
  | "confirmed"
  | "on_sale"
  | "active"
  | "completed"
  | "cancelled"
  | "planned"
  | "neutral";

export function statusToTone(status: string): EventStatusTone {
  const s = status.toLowerCase().replace(/\s+/g, "_");
  if (s.includes("hold")) return "hold";
  if (s === "confirmed" || s === "active") return "confirmed";
  if (s.includes("on_sale") || s === "on_sale") return "on_sale";
  if (s === "live" || s.includes("live")) return "active";
  if (s === "completed" || s === "settled" || s === "done") return "completed";
  if (s === "cancelled" || s === "canceled") return "cancelled";
  if (s === "planned" || s === "draft") return "planned";
  return "neutral";
}

export function formatStatusLabel(status: string): string {
  return status.replace(/_/g, " ");
}

type Props = {
  status: string;
  holdLevel?: number | null;
  /** Legend text from the API (`hold_label`); falls back to the built-in legend. */
  holdLabel?: string | null;
  className?: string;
  compact?: boolean;
};

export const StatusChip: React.FC<Props> = ({ status, holdLevel, holdLabel, className = "", compact = false }) => {
  const tone = statusToTone(status);
  const label = formatStatusLabel(status);

  return (
    <span
      className={`status-chip status-chip--${tone}${compact ? " status-chip--compact" : ""}${className ? ` ${className}` : ""}`}
      title={label}
    >
      {holdLevel ? (
        <span className="status-chip__hold" title={holdLabel ?? HOLD_LEVEL_LEGEND[holdLevel] ?? `Hold level ${holdLevel}`}>
          Hold {holdLevel}
        </span>
      ) : null}
      <span className="status-chip__label">{label}</span>
    </span>
  );
};
